/**
import bus from '@/util/bus'

// A页面触发事件
created() {
  bus.$on('getUser', this.getStaffs)
  // 页面销毁时移除事件
  this.$once('hook:beforeDestroy', () => {
    bus.$off('getUser')
  })
}

// B页面触发
bus.$emit('getUser')
 */
import Vue from 'vue'

const bus = new Vue()

export default bus
